/* unplugin-vue-components disabled */import { render } from "./BatchUpdateSpeach.vue?vue&type=template&id=69ac6048&scoped=true&ts=true"
import script from "./BatchUpdateSpeach.vue?vue&type=script&lang=ts"
export * from "./BatchUpdateSpeach.vue?vue&type=script&lang=ts"

import "./BatchUpdateSpeach.vue?vue&type=style&index=0&id=69ac6048&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ac6048"]])

export default __exports__